import React from 'react';
function WriteComment({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 11.23V5H3v10.196h4.148V18l3.2-2.804h3.882"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.367 17.469l2.173 2.187-2.173-2.187zM18.826 11l-6.46 6.469L11 21l3.54-1.344L21 13.188 18.826 11z"
      />
    </svg>
  );
}

export default WriteComment;
